/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Section_PaymentInputs */

const de_commons_footer_section_payment = /** @type {(inputs: Commons_Footer_Section_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicher bezahlen`)
};

/** @type {(inputs: Commons_Footer_Section_PaymentInputs) => LocalizedString} */
const en_commons_footer_section_payment = de_commons_footer_section_payment;

/**

* @param {Commons_Footer_Section_PaymentInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_section_payment = /** @type {((inputs?: Commons_Footer_Section_PaymentInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Section_PaymentInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_section_payment(inputs)
	return en_commons_footer_section_payment(inputs)
});